/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Premium_Per_WeekInputs */

const en_premium_per_week = /** @type {(inputs: Premium_Per_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/week`)
};

const es_premium_per_week = /** @type {(inputs: Premium_Per_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/semana`)
};

/**
* | output |
* | --- |
* | "/week" |
*
* @param {Premium_Per_WeekInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const premium_per_week = /** @type {((inputs?: Premium_Per_WeekInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Premium_Per_WeekInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_premium_per_week(inputs)
	return en_premium_per_week(inputs)
});